import * as React from 'react';
import { Edit, useNotify, useRedirect } from 'react-admin';
import { DirectoryContactForm } from './DirectoryContactForm';
import useAdmin from '../hooks/useAdmin';

export const DirectoryContactEdit = (props: any) => {
    const notify = useNotify();
    const redirect = useRedirect();

    const onSuccess = () => {
        notify('resources.directorycontacts.notification.updated', {
            type: 'info',
            undoable: true,
            messageArgs: { smart_count: 1, name: 'Directory Contact' }
        });
        redirect('/directorycontacts');
    };

    useAdmin();

    return (
        <Edit title="Edit Directory Contact" {...props} mutationOptions={{ onSuccess: onSuccess }}>
            <DirectoryContactForm isEdit={true} />
        </Edit>
    );
};

export default DirectoryContactEdit;
